import AuthService from 'cio/services/auth';
import { resolve } from 'rsvp';

export default class DemoAuthService extends AuthService {
  logout() {
    return resolve();
  }
}
